<div *ngIf="action === 'view'; then View; else Form"></div>

<ng-template #View>
  <div class="relative mb-4 sm:grid sm:grid-cols-2 md:grid-cols-3">
    <div class="col-start-1 sm:col-span-1 md:col-span-2">
      <h3 class="text-base font-semibold leading-7 text-gray-900">Información de la orden {{ order.number }}</h3>
    <!--p class="mt-1 max-w-2xl text-sm leading-6 text-gray-500">Personal details and application.</p-->
      
    </div>
    <div class ="hidden sm:col-span-1 sm:flex sm:flex-row-reverse">
      <button [routerLink]="['/orders/edit/' + order.id]" fragment="top" type="submit" class="w-1/2 sm:w-2/3 md:w-full lg:w-2/3 rounded-md primary-button px-3 py-2 text-sm font-semibold text-white shadow-sm">
        Editar Información de la orden
      </button>
    </div>
  </div>
  <div class="mt-6 border-t border-gray-100">
    <dl class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
      <div class="border-t border-gray-100 px-4 py-6 sm:col-span-1 sm:px-0">
        <dt class="text-sm font-medium leading-6 text-gray-900">Nº OT</dt>
        <dd class="mt-1 text-sm leading-6 text-gray-700 sm:mt-2">{{ order.number }}</dd>
      </div>
      <div class="border-t border-gray-100 px-4 py-6 sm:col-span-1 sm:px-0">
        <dt class="text-sm font-medium leading-6 text-gray-900">MC</dt>
        <dd class="mt-1 text-sm leading-6 text-gray-700 sm:mt-2">{{ order.mc ? 'Sí' : 'No' }}</dd>
      </div>
      <div class="border-t border-gray-100 px-4 py-6 sm:col-span-1 sm:px-0">
        <dt class="text-sm font-medium leading-6 text-gray-900">Solicitud</dt>
        <dd class="mt-1 text-sm leading-6 text-gray-700 sm:mt-2">{{ order.request ? order.request : '-' }}</dd>
      </div>
      <div class="border-t border-gray-100 px-4 py-6 sm:col-span-1 sm:px-0">
        <dt class="text-sm font-medium leading-6 text-gray-900">Comienzo</dt>
        <dd class="mt-1 text-sm leading-6 text-gray-700 sm:mt-2">{{ order.start_date ? dateService.formatDate(order.start_date) : '-' }}</dd>
      </div>
      <div class="border-t border-gray-100 px-4 py-6 sm:col-span-1 sm:px-0">
        <dt class="text-sm font-medium leading-6 text-gray-900">Plazo de Entrega</dt>
        <dd class="mt-1 text-sm leading-6 text-gray-700 sm:mt-2">{{ order.deliver_date ? dateService.formatDate(order.deliver_date) : '-' }}</dd>
      </div>
      <div class="border-t border-gray-100 px-4 py-6 sm:col-span-1 sm:px-0">
        <dt class="text-sm font-medium leading-6 text-gray-900">Entrega</dt>
        <dd class="mt-1 text-sm leading-6 text-gray-700 sm:mt-2">{{ order.delivery ? dateService.formatDate(order.delivery) : '-' }}</dd>
      </div>
      <div class="border-t border-gray-100 px-4 py-6 sm:col-span-1 sm:px-0">
        <dt class="text-sm font-medium leading-6 text-gray-900">Nueva fecha de entrega</dt>
        <dd class="mt-1 text-sm leading-6 text-gray-700 sm:mt-2">{{order.new_deliver_date ? order.new_deliver_date : '-'}}</dd>
      </div>
      <div class="border-t border-gray-100 px-4 py-6 sm:col-span-1 sm:px-0">
        <dt class="text-sm font-medium leading-6 text-gray-900">Valoración</dt>
        <dd class="mt-1 text-sm leading-6 text-gray-700 sm:mt-2">{{ order.review_date ? dateService.formatDate(order.review_date) : '-' }}</dd>
      </div>
    </dl>
  </div>

  <h2 class="mt-10 text-base font-semibold leading-7 text-gray-900 pb-2">Gamas</h2>
  <div class="py-3 sm:py-5 mx-auto">
    <div class="relative overflow-hidden bg-white shadow-md sm:rounded-lg">
      <div class="overflow-x-auto">
        <table class="w-full text-sm text-left text-gray-500">
          <thead class="text-xs text-gray-700 uppercase bg-gray-50">
            <tr>
              <th scope="col" class="px-4 py-3">Nº</th>
              <th scope="col" class="px-4 py-3">Designación</th>
              <th scope="col" class="px-4 py-3 flex flex-row-reverse">
                <button [routerLink]="['/gamas/create/' + order.id]" fragment="top" type="submit" class="rounded-md primary-button px-12 py-2 text-sm font-semibold text-white shadow-sm ">
                  Crear nueva gama
                </button>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let gama of sortedGamas(); let index = index" class="border-b border-gray-200 hover:bg-gray-50" [ngClass]="!gama.active ? 'bg-gray-200' : ''">
              <td [routerLink]="['/gamas/edit/' + gama.id]" fragment="top" scope="row" class="hover:cursor-pointer px-4 py-2">
                <span class="bg-primary-100 text-primary-800 text-xs font-medium py-0.5 rounded">
                  {{ gama.index }}
                </span>
              </td>
              <td [routerLink]="['/gamas/edit/' + gama.id]" fragment="top" scope="row" class="hover:cursor-pointer px-4 py-2">
                <span class="bg-primary-100 text-primary-800 text-xs font-medium py-0.5 rounded truncate">
                  {{ gama.designations[0] }}
                </span>
              </td>
              <td class="px-4 py-2 font-medium text-gray-900 whitespace-nowrap">
                <div class="flex flex-row-reverse">
                  <svg [routerLink]="['/gamas/edit/' + gama.id]" fragment="top" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-7 w-7 p-1 text-gray-800 hover:bg-gray-200 rounded-lg border border-gray-800 hover:cursor-pointer">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"/>
                  </svg>
                  <!-- <svg [routerLink]="['/gamas/view/' + gama.id]" xmlns="http://www.w3.org/2000/svg" fill="currentColor"  viewBox="0 0 576 512" stroke-width="1.5" stroke="none" class="h-7 w-7 me-1.5 p-1 primary-text-color hover:bg-gray-300 rounded-lg border primary-border-color hover:cursor-pointer">
                    <path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"/>
                    <path d="M14 10h4v2h-4z"></path>
                  </svg> -->
                  <svg (click)="saveGamaPDF(gama)" class="h-7 w-7 me-1.5 p-1 text-blue-800 hover:bg-blue-300 rounded-lg border border-blue-800 hover:cursor-pointer" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" >
                    <path fill-rule="evenodd" d="M7.875 1.5C6.839 1.5 6 2.34 6 3.375v2.99c-.426.053-.851.11-1.274.174-1.454.218-2.476 1.483-2.476 2.917v6.294a3 3 0 0 0 3 3h.27l-.155 1.705A1.875 1.875 0 0 0 7.232 22.5h9.536a1.875 1.875 0 0 0 1.867-2.045l-.155-1.705h.27a3 3 0 0 0 3-3V9.456c0-1.434-1.022-2.7-2.476-2.917A48.716 48.716 0 0 0 18 6.366V3.375c0-1.036-.84-1.875-1.875-1.875h-8.25ZM16.5 6.205v-2.83A.375.375 0 0 0 16.125 3h-8.25a.375.375 0 0 0-.375.375v2.83a49.353 49.353 0 0 1 9 0Zm-.217 8.265c.178.018.317.16.333.337l.526 5.784a.375.375 0 0 1-.374.409H7.232a.375.375 0 0 1-.374-.409l.526-5.784a.373.373 0 0 1 .333-.337 41.741 41.741 0 0 1 8.566 0Zm.967-3.97a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75H18a.75.75 0 0 1-.75-.75V10.5ZM15 9.75a.75.75 0 0 0-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75V10.5a.75.75 0 0 0-.75-.75H15Z" clip-rule="evenodd" />
                  </svg>
                  <div *ngIf="gama.active; then Active; else Inactive"></div>
                  <ng-template #Active>
                    <svg (click)="updateGamaStatus(gama)" fragment="top" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-7 w-7 p-1 text-red-600 hover:bg-red-200 rounded-lg border border-red-600 hover:cursor-pointer me-2">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M18.364 18.364A9 9 0 0 0 5.636 5.636m12.728 12.728A9 9 0 0 1 5.636 5.636m12.728 12.728L5.636 5.636" />
                    </svg>
                  </ng-template>
                  <ng-template #Inactive>
                    <svg (click)="updateGamaStatus(gama)" fragment="top" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-7 w-7 p-1 text-green-600 hover:bg-green-200 rounded-lg border border-green-600 hover:cursor-pointer me-2">
                      <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                    </svg>
                  </ng-template>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="grid grid-cols-3 h-fit mb-10">
    <div id="chart" class="col-start-2">
      <apx-chart *ngIf="cheese_chart_options.series.length > 0"
      [series]="cheese_chart_options.series"
      [chart]="cheese_chart_options.chart"
      [labels]="cheese_chart_options.labels"
      [title]="cheese_chart_options.title"
      [theme]="cheese_chart_options.theme"
      [responsive]="cheese_chart_options.responsive"
      [dataLabels]="cheese_chart_options.dataLabels"
      [tooltip]="cheese_chart_options.tooltip"
    ></apx-chart>
    </div>
  </div>
    
  <!-- Button for windows < md -->
  <div class="mt-6 flex items-center gap-x-6 justify-center sm:hidden">
    <button [routerLink]="['/orders/edit/' + order.id]" fragment="top" type="submit" class="rounded-md primary-button px-12 py-2 text-sm font-semibold text-white shadow-sm ">
      Editar información de la OT
    </button>
  </div>
  <!-- End button -->
</ng-template>



<ng-template #Form>
  <form [formGroup]="order_form" class="space-y-6" action="#" method="POST">
    <div class="grid grid-cols-6 gap-3">
      <div class="col-span-5">
        <label class="ms-1 text-sm text-gray-800">
          Cliente
        </label>
        <div class="relative mt-2 rounded-md shadow-sm">
          <input type="text" name="client" id="client" class="form-control block w-full rounded-xl border-0 py-2 px-3 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 sm:text-sm sm:leading-6 focus:primary-ring-color outline-none appearance-none"
            placeholder="Cliente"
            formControlName="client"
            autocomplete="off" [ngClass]="{
              'is-invalid': order_form.controls['client'].invalid,
              'is-valid': order_form.controls['client'].valid}"
          />
        </div>
      </div>

      <div class="col-span-1">
        <label class="ms-1 text-sm text-gray-800 flex justify-center mr-5">
          MC
        </label>
        <div class="relative mt-2 rounded-md shadow-sm">
          <div class="mt-2 flex justify-center">
            <label class="relative inline-flex items-center mr-5 cursor-pointer mt-2">
              <input 
              formControlName="mc"
              autocomplete="off" [ngClass]="{
                'is-invalid': order_form.controls['mc'].invalid,
                'is-valid': order_form.controls['mc'].valid}"
              id="mc" type="checkbox" class="sr-only peer">
              <div class="w-11 h-6 bg-gray-600 rounded-full peer peer-focus:primary-ring-color peer-focus:primary-ring-color peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-600 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:primary-bg-color"></div>
            </label>
          </div>
        </div>
      </div>

      <div class="col-span-4">
        <label class="ms-1 text-sm text-gray-800">
          Denominación
        </label>
        <div class="relative mt-2 rounded-md shadow-sm">
          <input type="text" name="denomination" id="denomination" class="form-control block w-full rounded-xl border-0 py-2 px-3 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 sm:text-sm sm:leading-6 focus:primary-ring-color outline-none appearance-none"
            placeholder="Denominación"
            formControlName="denomination"
            autocomplete="off" [ngClass]="{
              'is-invalid': order_form.controls['denomination'].invalid,
              'is-valid': order_form.controls['denomination'].valid}"
          />
        </div>
      </div>

      <div class="col-span-2">
        <label class="ms-1 text-sm text-gray-800">
          Pedido o solicitud
        </label>
        <div class="relative mt-2 rounded-md shadow-sm">
          <input type="text" name="request" id="request" class="form-control block w-full rounded-xl border-0 py-2 px-3 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 sm:text-sm sm:leading-6 focus:primary-ring-color outline-none appearance-none"
            placeholder="Pedido o solicitud"
            formControlName="request"
            autocomplete="off" [ngClass]="{
              'is-invalid': order_form.controls['request'].invalid,
              'is-valid': order_form.controls['request'].valid}"
          />
        </div>
      </div>
      
      <div class="col-span-2">
        <label class="ms-1 text-sm text-gray-800">
          Fecha de comienzo
        </label>
        <div class="relative mt-2 rounded-md shadow-sm">
          <input [owlDateTime]="start_date" [owlDateTimeTrigger]="start_date" class="form-control block w-full rounded-xl border-0 py-2 px-3 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 sm:text-sm sm:leading-6 focus:primary-ring-color outline-none appearance-none"
          placeholder="Selecciona una fecha"
          formControlName="start_date"
          autocomplete="off" [ngClass]="{
            'is-invalid': order_form.controls['start_date'].invalid,
            'is-valid': order_form.controls['start_date'].valid}">
          <owl-date-time #start_date pickerType="calendar"></owl-date-time>
        </div>
      </div>

      <div class="col-span-2">
        <label class="ms-1 text-sm text-gray-800">
          Plazo de entrega
        </label>
        <div class="relative mt-2 rounded-md shadow-sm">
          <input [owlDateTime]="deliver_date" [owlDateTimeTrigger]="deliver_date" class="form-control block w-full rounded-xl border-0 py-2 px-3 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 sm:text-sm sm:leading-6 focus:primary-ring-color outline-none appearance-none"
          placeholder="Selecciona una fecha"
          formControlName="deliver_date"
          autocomplete="off" [ngClass]="{
            'is-invalid': order_form.controls['deliver_date'].invalid,
            'is-valid': order_form.controls['deliver_date'].valid}">
          <owl-date-time #deliver_date pickerType="calendar"></owl-date-time>
        </div>
      </div>

      <div class="col-span-2">
        <label class="ms-1 text-sm text-gray-800">
          Entrega
        </label>
        <div class="relative mt-2 rounded-md shadow-sm">
          <input [owlDateTime]="delivery" [owlDateTimeTrigger]="delivery" class="form-control block w-full rounded-xl border-0 py-2 px-3 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 sm:text-sm sm:leading-6 focus:primary-ring-color outline-none appearance-none"
          placeholder="Selecciona una fecha"
          formControlName="delivery"
          autocomplete="off" [ngClass]="{
            'is-invalid': order_form.controls['delivery'].invalid,
            'is-valid': order_form.controls['delivery'].valid}">
          <owl-date-time #delivery pickerType="calendar"></owl-date-time>
        </div>
      </div>

      <div class="col-span-3">
        <label class="ms-1 text-sm text-gray-800">
          Nuevo Plazo de Entrega
        </label>
        <div class="relative mt-2 rounded-md shadow-sm">
          <input type="text" name="new_deliver_date" id="new_deliver_date" class="form-control block w-full rounded-xl border-0 py-2 px-3 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 sm:text-sm sm:leading-6 focus:primary-ring-color outline-none appearance-none"
            placeholder="Pedido o solicitud"
            formControlName="new_deliver_date"
            autocomplete="off" [ngClass]="{
              'is-invalid': order_form.controls['new_deliver_date'].invalid,
              'is-valid': order_form.controls['new_deliver_date'].valid}"
          />
        </div>
      </div>

      <div class="col-span-3">
        <label class="ms-1 text-sm text-gray-800">
          Fecha de valoración
        </label>
        <div class="relative mt-2 rounded-md shadow-sm">
          <input [owlDateTime]="review_date" [owlDateTimeTrigger]="review_date" class="form-control block w-full rounded-xl border-0 py-2 px-3 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 sm:text-sm sm:leading-6 focus:primary-ring-color outline-none appearance-none"
          placeholder="Selecciona una fecha"
          formControlName="review_date"
          autocomplete="off" [ngClass]="{
            'is-invalid': order_form.controls['review_date'].invalid,
            'is-valid': order_form.controls['review_date'].valid}">
          <owl-date-time #review_date pickerType="calendar"></owl-date-time>
        </div>
      </div>
    </div>


    <div class="flex justify-end py-4 gap-x-3">
      <button [disabled]="form_in_progress" routerLink="{{ action ==='crear' ? '/orders' : '/orders/view/' + order.id}}" type="button" class="primary-button flex justify-center rounded-xl px-10 py-2.5 text-base font-semibold leading-6 shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-700">
        Cancelar
      </button>

      <div *ngIf="action === 'create'; then Create; else Edit"></div>
      <ng-template #Create>
        <button [disabled]="form_in_progress" (click)="registerOrder()" type="submit" class="primary-button flex justify-center rounded-xl px-10 py-2.5 text-base font-semibold leading-6 shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-700">
          Crear
        </button>
      </ng-template>
      
      <ng-template #Edit>
        <button [disabled]="form_in_progress" (click)="updateOrder()" type="submit" class="primary-button flex justify-center rounded-xl px-10 py-2.5 text-base font-semibold leading-6 shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-700">
          Confirmar
        </button>
      </ng-template>
    </div>
  </form>
</ng-template>